module.exports = __webpack_public_path__ + "img/charging-infrastructure-terms-en.021c828d.jpg";